export default __webpack_public_path__ + "static/media/Bell.c52c1093.svg";